import StylesheetLoader from './stylesheet-loader';

export default function createStylesheetLoader(): StylesheetLoader {
    return new StylesheetLoader();
}
